class ArtikelAnsicht3D extends HTMLElement {
    static get observedAttributes() {
        return ['data-status'];
    }

    connectedCallback() {
        this.ansicht3dViewer = this.querySelector('.model3dviewer');
        __webpack_public_path__ = `${this.dataset["assetBaseUri"]}/artikel-ansicht3d/`;
        this.initAnsicht3D();
        document.addEventListener('ansicht3d-oeffnen', () => {
            this.overlayStatus = 'open'
        });
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-status") this.toggleOverlay(newValue);
    }

    toggleOverlay(value) {
        this.ansicht3dOverlay = this.querySelector('.ansicht3d-overlay');
        if (value === 'open') {
            this.ansicht3dOverlay.showModal();
            this.ansicht3dViewer.focus();
            return;
        }
        this.ansicht3dOverlay.close();
    }

    initAnsicht3D() {
        this.ansicht3dViewer.addEventListener('load', () => {
            this.ladeindikatorStatus = 'inaktiv';
        });
        this.addEventListener('submit', (event) => {
            event.preventDefault();
            this.overlayStatus = 'open';
        });
        this.querySelector('[interaction="ansicht3d-schliessen"]').addEventListener('click', () => {
            this.overlayStatus = 'close';
        });

        // load model-viewer.js file
        this.initModelViewer();
    }

    async initModelViewer() {
        try {
            const { ModelViewerElement } = await import(/* webpackChunkName: "model-viewer" */ "@google/model-viewer");
            this.querySelector(".ar-button").removeAttribute("hidden");
        } catch (error) {
            console.error(error);
        }
    }

    set ladeindikatorStatus(wert) {
        this.ladeIndikator = this.querySelector('.ladeindikator');
        if (this.ladeIndikator) this.ladeIndikator.setAttribute('data-status', wert);
    }

    set overlayStatus(wert) {
        this.setAttribute('data-status', wert);
    }

    get ansicht3dNichtGeladen() {
        return this.ansicht3dViewer.hasAttribute('src') === false;
    }
}

if (!customElements.get("artikel-ansicht3d")) {
    customElements.define("artikel-ansicht3d", ArtikelAnsicht3D);
}
